export var FlowDirectionType;
(function (FlowDirectionType) {
    FlowDirectionType[FlowDirectionType["Positive"] = 0] = "Positive";
    FlowDirectionType[FlowDirectionType["Negative"] = 1] = "Negative";
})(FlowDirectionType || (FlowDirectionType = {}));
